'use client';
import React from 'react';
import Slider from 'react-slick';
import Image from 'next/image';

const ProjectSlider = ({ images }: any) => {
    const sliderSettings = {
        dots: false,
        arrow: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '28px',
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    centerPadding: '15px',
                    focusOnSelect: true,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '10px',
                    focusOnSelect: true,
                },
            },
        ],
    };
    return (
        <div className="section dark:bg-black section-slider-screens relative section-py pb-0">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-10">
                        <h2 className="text-primary mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Screens
                        </h2>
                    </div>
                </div>
            </div>
            <div className="px-0 mx-auto">
                <div className="flex flex-wrap relative items-center justify-center">
                    <div className="md:w-full max-w-[2000px]">
                        <div className="ipad-frame-box text-center">
                            <div className="ipad-frame-main">
                                <Image
                                    src="/img/img-frame-bg@2x.webp"
                                    alt="outline one"
                                    width={1067}
                                    height={669}
                                    className="img-fluid"
                                    loading="lazy"
                                />
                            </div>
                            <div className="video-frame">
                                <Slider {...sliderSettings} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                    {images.map((image: any, index: number) => {
                                        return (
                                            <div key={index}>
                                                <div className="slide-one w-full inline-block cursor-pointer">
                                                    <Image
                                                        src={image.attachments}
                                                        alt="outline one"
                                                        width={1067}
                                                        height={669}
                                                        className="img-fluid"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ProjectSlider;
